import i18n from '@/i18n';
import loadable from '@loadable/component';
//$IMPORT$

export default () => [
  {
    needLogin: true,
    resourceName: i18n.t('CompanyBill-index-1992f2b8250ea63f1-1'),
    routerUrl: '/CompanyBill',
    resourceIcon: 'TeamOutlined',
    type: '0',
    buttons: [],
    noparent: true,
    component: loadable(() => import('./CompanyBill')),
    children: [
      {
        needLogin: true,
        resourceName: i18n.t('CompanyBill-index-1992f2b8250ea63f1-2'),
        routerUrl: '/CompanyBillForm',
        resourceIcon: '',
        type: '2',
        buttons: [],
        component: loadable(() => import('./CompanyBillForm')),
      },
      //$MORE$
    ],
  },
];
